<section class="l-auth">
  <div class="l-auth-sliderWrapper">
    <div class="l-auth-slider">
      <swiper [config]="config" dir="rtl">
        <ng-template swiperSlide>
          <!-- =============================== -->
          <div>
            <div class="l-auth-cover">
              <img
                src="./assets/images/login/login-img-1.png"
                alt=""
                class="image"
              />
            </div>
            <p class="l-auth-desc">
              {{
                "An event control panel to control all event data and details such as ticket fees and discount coupons"
                  | translate
              }}
            </p>
          </div>
          <!-- =============================== -->
        </ng-template>
        <ng-template swiperSlide>
          <!-- =============================== -->
          <div>
            <div class="l-auth-cover">
              <img
                src="./assets/images/login/login-img-2.png"
                alt=""
                class="image"
              />
            </div>
            <p class="l-auth-desc">
              {{
                "Provide immediate and detailed reports and statistics before and after the event on the registration movement and their data"
                  | translate
              }}
            </p>
          </div>
          <!-- =============================== -->
        </ng-template>
        <ng-template swiperSlide>
          <!-- =============================== -->
          <div>
            <div class="l-auth-cover">
              <img
                src="./assets/images/login/login-img-3.png"
                alt=""
                class="image"
              />
            </div>
            <p class="l-auth-desc">
              {{
                "Providing an integrated electronic system to manage all types of events and conferences in an easy and simple manner"
                  | translate
              }}
            </p>
          </div>
          <!-- =============================== -->
        </ng-template>
        <ng-template swiperSlide>
          <!-- =============================== -->
          <div>
            <div class="l-auth-cover">
              <img
                src="./assets/images/login/login-img-4.png"
                alt=""
                class="image"
              />
            </div>
            <p class="l-auth-desc">
              {{
                "Provide immediate and detailed reports and statistics before and after the event on the registration movement and their data"
                  | translate
              }}
            </p>
          </div>
          <!-- =============================== -->
        </ng-template>
      </swiper>
    </div>
  </div>
  <div class="l-auth-mainWrapper">
    <div>
      <a class="flex justify-center !mt-3 w-8 mx-auto" routerLink="/">
        <img *ngIf="translate.currentLang === 'ar'" src="/assets/images/evento-logo.svg" alt="" class="w-full" />
        <img *ngIf="translate.currentLang === 'en'" src="/assets/images/evento-logo-en.svg" alt="" class="w-full" />
        </a>
    </div>
    <router-outlet></router-outlet>
  </div>
</section>
